export default __webpack_public_path__ + "static/media/Twitter 3d logo.5af60788.svg";